document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("modale-recommendation");
  const closeModal = document.querySelector(".modale_cart_close");
  const closeModalBtn = document.querySelector(".close_modale");
  const shopButton = document.querySelector(".modale_continue_first");
  const pageContent = document.querySelector(".page-content");
  let variantId = getVariantId();
  let modalIsVisible = 0;

  setupVariantRadioListeners();
  setupSubscriptionListener();
  setupModalEvents();
  tryFallbackRecommendations();

  // Variant ID utility
  function getVariantId() {
    try {
      const url = new URL(window.location.href);
      let id = url.searchParams.get("variant");
      if (!id) {
        const subElement = document.getElementById("modale_subscription");
        id = subElement ? subElement.dataset.value : null;
      }
      return id;
    } catch (error) {
      console.error("Error extracting variant ID:", error);
      return null;
    }
  }

  // Handle subscription select changes
  function setupSubscriptionListener() {
    const subSelect = document.getElementById("modale_subscription");
    if (subSelect) {
      subSelect.addEventListener("change", function (event) {
        if (event.target.selectedIndex !== 0) {
          event.target.classList.add("no-border");
        } else {
          event.target.classList.remove("no-border");
        }

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            selling_plan: event.target.value
          })
        }).then(() => {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added',{
              detail: {
              }
            })
          )
        });
      });
    }
  }

  // Modal event setup
  function setupModalEvents() {
    if (closeModal) closeModal.addEventListener("click", closeModalAndOpenCart);
    if (shopButton) shopButton.addEventListener("click", closeModalAndReset);
    if (shopButton) closeModalBtn.addEventListener("click", closeModalAndReset);

    document.addEventListener("ajaxProduct:added", handleAjaxProductAdded);

    document.addEventListener("click", function (event) {
      if (event.target === document.body) {
        closeModalAndReset();
      }
    });
  }

  function closeModalAndReset() {
    document.documentElement.style.overflow = "auto";
    modal.style.display = "none";
    document.documentElement.classList.remove("js-drawer-open");
    modalIsVisible = 0;
  }

  function closeModalAndOpenCart() {
    document.documentElement.style.overflow = "auto";
    modal.style.display = "none";
    pageContent.style.filter = "";
    pageContent.style.backgroundColor = "";
    modalIsVisible = 0;
  }

  function handleAjaxProductAdded(event) {
    const cart = document.getElementById("CartDrawer");

    switch (true) {
      case cart && cart.classList.contains("drawer--is-open"):
        break;

      case modalIsVisible >= 2:
        document.dispatchEvent(new CustomEvent("Modale:added"));
        document.documentElement.style.overflow = "auto";
        modal.style.display = "none";
        pageContent.style.filter = "";
        pageContent.style.backgroundColor = "";
        modalIsVisible = 0;
        break;

      default:
        document.documentElement.style.overflow = "hidden";
        modal.style.display = "block";
        document.documentElement.classList.add("js-drawer-open");
        modalIsVisible += 1;
        break;
    }
  }

  // Variant radio logic
  function setupVariantRadioListeners() {
    const radios = document.querySelectorAll('.variant-input-wrap input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener("change", function () {
        const selectedRadio = document.querySelector('.variant-input-wrap input[type="radio"]:checked');
        const formatDisplay = document.querySelector('.modale_format');

        if (selectedRadio && formatDisplay) {
          formatDisplay.innerText = selectedRadio.value;
          variantId = getVariantId();
        }
      });
    });
  }

  // Fallback recommendations logic
  function tryFallbackRecommendations() {
    const container = document.getElementById("modale-recommendations-js");
    if (!container) return;

    const productId = container.dataset.productId;
    if (productId) {
      loadFallbackRecommendations(productId, container);
    } else {
      console.warn("No product ID found in fallback container.");
    }
  }


  function loadFallbackRecommendations(productId, container) {
    fetch(`/recommendations/products.json?product_id=${productId}`)
      .then(res => res.json())
      .then(data => {
        const products = data.products.slice(0, 4);
        products.forEach(product => {
          const isCustom = product.handle.includes("personnalisee") || product.handle.includes("personalized");
          const price = (product.price / 100).toFixed(2);

          const html = `
            <div class="modale_reco_product">
              <a href="/products/${product.handle}">
                <img src="${product.featured_image}" width="200em" height="200em" class="modale_image modale_reco_image">
                <p class="modale_reco_title">${product.title}</p>
              </a>
              ${isCustom ? `
                <span class="modale_form">
                  <p class="modale_top">$${price}</p>
                  <a href="/products/${product.handle}" class="modale_add modale_perso">
                    <!-- SVG ICON -->+
                  </a>
                </span>
              ` : `
           
              `}
            </div>
          `;

          container.insertAdjacentHTML("beforeend", html);
        });
      })
      .catch(err => console.error("Error loading recommendations:", err));
  }
});
